export default __webpack_public_path__ + "static/media/tagaytay-enactment.428b3f8c.gif";